import React from 'react';
import { Text } from 'theme-ui';

function FootnoteText({ cartNote }: { cartNote: Queries.CartNotesQuery['contentfulNotification'] }) {
  if (cartNote?.description?.childMarkdownRemark?.html) {
    return (
      <Text
        as="span"
        sx={{
          textAlign: 'center',
          fontSize: '11px',
          lineHeight: '12px',
          fontFamily: 'body',
          fontWeight: '500',
          py: '2rem',
          a: {
            textDecoration: 'underline',
            cursor: 'pointer',
          },
        }}
        dangerouslySetInnerHTML={{ __html: cartNote.description.childMarkdownRemark.html }}
      />
    );
  }
  return null;
}

export default FootnoteText;
